"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extend = _interopRequireDefault(require("lodash/extend"));

var _config = _interopRequireDefault(require("./config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global _postal, SubscriptionDefinition, _config, _ */
var ChannelDefinition = function ChannelDefinition(channelName, bus) {
  this.bus = bus;
  this.channel = channelName || _config.default.DEFAULT_CHANNEL;
};

ChannelDefinition.prototype.subscribe = function () {
  return this.bus.subscribe({
    channel: this.channel,
    topic: arguments.length === 1 ? arguments[0].topic : arguments[0],
    callback: arguments.length === 1 ? arguments[0].callback : arguments[1]
  });
};
/*
    publish( envelope [, callback ] );
    publish( topic, data [, callback ] );
*/


ChannelDefinition.prototype.publish = function () {
  var envelope = {};
  var callback;

  if (typeof arguments[0] === "string") {
    envelope.topic = arguments[0];
    envelope.data = arguments[1];
    callback = arguments[2];
  } else {
    envelope = arguments[0];
    callback = arguments[1];
  }

  if (typeof envelope !== "object") {
    throw new Error("The first argument to ChannelDefinition.publish should be either an envelope object or a string topic.");
  }

  envelope.headers = (0, _extend.default)(envelope.headers || {
    resolverNoCache: _config.default.resolverNoCache
  });
  envelope.channel = this.channel;
  this.bus.publish(envelope, callback);
};

var _default = ChannelDefinition;
exports.default = _default;